<template lang="pug">
  .container-roleList.container-padding
    c-header
      template(slot="left")
        h3 角色管理
      template(slot="right")
        el-button(type="primary", @click="showCreate") 添加角色
    c-box
      el-table(:data="list", fit, v-loading="listLoading")
        el-table-column(property="id", label="ID", min-width="100", show-tooltip-when-overflow)
        el-table-column(property="title", label="角色名称", min-width="150", show-tooltip-when-overflow)
        el-table-column(property="desc", label="描述", min-width="150", show-tooltip-when-overflow)
        el-table-column(property="create_time", label="创建时间", min-width="175", show-tooltip-when-overflow)
        el-table-column(label="状态", min-width="100", show-tooltip-when-overflow, v-slot="{ row }")
          el-switch(v-model="row.status", :active-value="1", :inactive-value="2", @change='changeStatus(row)')
        el-table-column(label="操作", width="250", v-slot="{ row }")
          .row-toolbox
            el-button(type="primary", @click="showEdit(row)") 编辑
            el-button(type="primary", @click="showGrantPrivileges(row.id)") 资源授权
      .container-pagination
        el-pagination(layout="sizes, prev, pager, next, total",
          :current-page="page", :total="total", :page-size="size", :page-sizes="[5, 10, 15, 20, 25, 50]",
          @size-change="changeListSize", @current-change="getList")

    el-dialog(title="添加角色", :visible.sync="create.show")
      el-form(:model="create.source", label-position="right", label-width="125px", :validate-on-rule-change="false")
        el-form-item(label="角色名称", required)
          el-input(v-model="create.source.title")
        el-form-item(label="描述", required)
          el-input(v-model="create.source.desc")
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="saveCreate()") 保存
        el-button(@click="hideCreate()") 取消

    el-dialog(title="修改角色", :visible.sync="edit.show")
      el-form(:model="edit.source", label-position="right", label-width="125px", :validate-on-rule-change="false")
        el-form-item(label="角色名称", required)
          el-input(v-model="edit.source.title")
        el-form-item(label="描述", required)
          el-input(v-model="edit.source.desc")
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="saveEdit()") 保存
        el-button(@click="hideEdit()") 取消

    el-dialog(title="资源授权", :visible.sync="grantPrivileges.show", v-loading="grantPrivileges.loading", width="800px", top="3%")
      role-tree(:resource_ids.sync="grantPrivileges.source.resource_ids")
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="saveGrantPrivileges()") 保存
        el-button(@click="hideGrantPrivileges()") 取消
</template>

<script>
import roleTree from '../components/roleTree';
export default {
  data () {
    return {
      page:   1,
      size:   20,
      status: 0,
      list:   [],
      total:  0,

      listLoading:  false,

      create: {
        show:   false,
        source: {
          parent_id:  null,
          title:      null,
          desc:       null,
        },
      },

      edit:   {
        show:   false,
        source: {
          role_id:    null,
          parent_id:  null,
          title:      null,
          desc:       null,
        },
      },

      grantPrivileges: {
        show:     false,
        source:   {
          role_id:      null,
          resource_ids: null,
        },
        loading:  false,
      },
    };
  },
  computed: {
    privileges () {
      return this.$store.getters.privileges;
    },
  },
  methods: {
    showCreate () {
      this.create = {
        show:   true,
        source: {
          parent_id:  null,
          title:      null,
          desc:       null,
        },
      };
    },
    hideCreate () {
      this.create = {
        show:   false,
        source: {
          parent_id:  null,
          title:      null,
          desc:       null,
        },
      };
    },
    saveCreate () {
      if (this.saveValidate()) {
        this.$store.dispatch('CREATE_ROLE', this.create.source).then(() => {
          this.hideCreate();
          this.getList(1);

          this.$message({
            type:     'success',
            message:  '用户角色添加成功。'
          });
        }).catch(({ code, msg }) => {
          this.$message({
            type:     'error',
            message:  `用户角色添加失败。${code}：${msg}`,
          });
        });
      }
    },
    saveValidate () {
      if (!this.create.source.title) {
        this.$message({
          type:     'warning',
          message:  `请输入角色名称`,
        });
        return false;
      } else if (!this.create.source.desc) {
        this.$message({
          type:     'warning',
          message:  `请输入角色描述`,
        });
        return false;
      }
      return true;
    },

    showEdit ({ id, parent_id, title, desc }) {
      this.edit = {
        show:   true,
        source: {
          role_id:    id,
          parent_id,
          title,
          desc,
        },
      };
    },
    hideEdit () {
      this.edit = {
        show:   false,
        source: {
          role_id:    null,
          parent_id:  null,
          title:      null,
          desc:       null,
        },
      };
    },
    saveEdit () {
      if (this.editValidate()) {
        this.$store.dispatch('EDIT_ROLE', this.edit.source).then(() => {
          this.hideEdit();
          this.refresh(1);

          this.$message({
            type:     'success',
            message:  '用户角色修改成功。'
          });
        }).catch(({ code, msg }) => {
          this.$message({
            type:     'error',
            message:  `用户角色修改失败。${code}：${msg}`,
          });
        });
      }
    },
    editValidate () {
      if (!this.edit.source.title) {
        this.$message({
          type:     'warning',
          message:  `请输入角色名称`,
        });
        return false;
      } else if (!this.edit.source.desc) {
        this.$message({
          type:     'warning',
          message:  `请输入角色描述`,
        });
        return false;
      }
      return true;
    },

    showGrantPrivileges (id) {
      this.grantPrivileges = {
        show:     true,
        source:   {
          role_id:      id,
          resource_ids: null,
        },
        loading:  true,
      };
      this.getPrivilegeByRole(id).then((data) => {
        let privilegeSource = [];
        data.forEach((d) => {
          privilegeSource.push(d.resource_id);
        });
        this.grantPrivileges.source.resource_ids = privilegeSource.join(',');
      }).finally(() => {
        this.grantPrivileges.loading = false;
      });
    },
    hideGrantPrivileges () {
      this.grantPrivileges = {
        show:     false,
        source:   {
          role_id:      null,
          resource_ids: null,
        },
        loading:  false,
      };
    },
    saveGrantPrivileges () {
      this.grantPrivileges.loading = true;
      this.$store.dispatch('EDIT_ROLE_PRIVILEGE', this.grantPrivileges.source).then(() => {
        this.hideGrantPrivileges();

        this.$message({
          type:     'success',
          message:  '资源授权成功。'
        });
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `资源授权失败。${code}：${msg}`,
        });
      }).finally(() => {
        this.grantPrivileges.loading = false;
      });
    },

    changeStatus ({ id, status }) {
      this.$store.dispatch('UPDATE_ROLE_STATUS', {
        role_id:  id,
        status,
      }).then(() => {
        this.$message({
          type:     'success',
          message:  '状态修改成功'
        });

        this.refresh();
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `状态修改失败：${code}：${msg}`
        });
        this.refresh();
      });
    },

    getPrivilegeByRole (role_id) {
      return this.$store.dispatch('GET_ROLE_PRIVILEGE', role_id);
    },

    refresh () {
      this.getList(this.page);
    },
    changeListSize (size = 20) {
      this.size = size;
      this.getList(1);
    },
    getList (page = 1) {
      if (!this.listLoading) {
        this.page = page;
        this.listLoading = true;
      } else {
        return;
      }

      this.$store.dispatch('GET_ROLE_LIST', {
        offset:   this.size * (this.page - 1),
        limit:    this.size,
        stat:     true,
      }).then((data) => {
        this.list = data.list;
        this.total = data.total;
      }).catch(({ msg }) => {
        this.$alert(`${msg}`, {
          type:     'error'
        });
      }).finally(() => {
        this.listLoading = false;
      });
    },
  },
  mounted () {
    this.getList(1);
  },
  components: {
    roleTree
  }
};
</script>